import React from "react";
import {
  BadgeDollarSign,
  DatabaseBackup,
  Package,
  PackageX,
  RectangleEllipsis,
  Truck,
  Wallet,
  Wallet2,
} from "lucide-react";
import CountUp from "react-countup";
import { DashboardSummaryResult } from "../../../models/reports/dashboard-summary";
import { SalesMonthChart } from "./charts";

interface Props {
  summary?: DashboardSummaryResult;
}
const Widgets: React.FC<Props> = ({ summary }) => {
  return (
    <React.Fragment>
      <div className="col-span-12 card md:col-span-6 lg:col-span-4 2xl:col-span-2">
        <div className="text-center card-body">
          <div className="flex items-center justify-center mx-auto rounded-full size-14 bg-custom-100 text-custom-500 dark:bg-custom-500/20">
            <Package />
          </div>
          <h5 className="mt-4 mb-2">
            <CountUp end={summary?.totalSalesAmount ?? 0} decimals={2} className="counter-value" />
          </h5>
          <p className="text-slate-500 dark:text-zink-200">Total Sales Amount</p>
        </div>
      </div>
      <div className="col-span-12 card md:col-span-6 lg:col-span-4 2xl:col-span-2">
        <div className="text-center card-body">
          <div className="flex items-center justify-center mx-auto text-purple-500 bg-purple-100 rounded-full size-14 dark:bg-purple-500/20">
            <Wallet2 />
          </div>
          <h5 className="mt-4 mb-2">
            <CountUp end={summary?.totalSalesCount ?? 0} className="counter-value" />
          </h5>
          <p className="text-slate-500 dark:text-zink-200">Total Sales Count</p>
        </div>
      </div>
      <div className="col-span-12 card md:col-span-6 lg:col-span-4 2xl:col-span-2">
        <div className="text-center card-body">
          <div className="flex items-center justify-center mx-auto rounded-full size-14 bg-red-100 text-red-500 dark:bg-red-500/20">
            <RectangleEllipsis />
          </div>
          <h5 className="mt-4 mb-2">
            <CountUp end={summary?.paymentPendingAmount ?? 0} decimals={2} className="counter-value" />
          </h5>
          <p className="text-slate-500 dark:text-zink-200">Payment Pending Amount</p>
        </div>
      </div>
      <div className="col-span-12 card md:col-span-6 lg:col-span-3 2xl:col-span-2">
        <div className="text-center card-body">
          <div className="flex items-center justify-center mx-auto text-red-500 bg-red-100 rounded-full size-14 dark:bg-red-500/20">
            <BadgeDollarSign />
          </div>
          <h5 className="mt-4 mb-2">
            <CountUp end={summary?.dailySalesAmount ?? 0} decimals={2} className="counter-value" />
          </h5>
          <p className="text-slate-500 dark:text-zink-200">Daily Sales Amount</p>
        </div>
      </div>
      <div className="col-span-12 card md:col-span-6 lg:col-span-3 2xl:col-span-2">
        <div className="text-center card-body">
          <div className="flex items-center justify-center mx-auto text-green-500 bg-green-100 rounded-full size-14 dark:bg-green-500/20">
            <Truck />
          </div>
          <h5 className="mt-4 mb-2">
            <CountUp end={summary?.dailySalesCount ?? 0} className="counter-value" />
          </h5>
          <p className="text-slate-500 dark:text-zink-200">Daily Sales Count</p>
        </div>
      </div>

      <div className="col-span-12 card md:col-span-6 lg:col-span-3 2xl:col-span-2">
        <div className="text-center card-body">
          <div className="flex items-center justify-center mx-auto rounded-full size-14 bg-custom-100 text-custom-500 dark:bg-custom-500/20">
            <DatabaseBackup />
          </div>
          <h5 className="mt-4 mb-2">
            <CountUp end={summary?.monthlySalesAmount ?? 0} decimals={2} className="counter-value" />
          </h5>
          <p className="text-slate-500 dark:text-zink-200">Monthly Sales Amount</p>
        </div>
      </div>
      <div className="col-span-12 card md:col-span-6 lg:col-span-3 2xl:col-span-2">
        <div className="text-center card-body">
          <div className="flex items-center justify-center mx-auto text-purple-500 bg-purple-100 rounded-full size-14 dark:bg-purple-500/20">
            <Wallet />
          </div>
          <h5 className="mt-4 mb-2">
            <CountUp end={summary?.monthlySalesCount ?? 0} className="counter-value" />
          </h5>
          <p className="text-slate-500 dark:text-zink-200">Monthly Sales Count</p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Widgets;
